import type { Notification, NotificationTypes } from "@/generatedApi";
import { toast } from "vue-sonner";

const notificationInfoToast = (notification: Notification) => {
	toast.info(notification.metadata.message, {
		description: notification.metadata.description,
	});
};

const notificationSuccessToast = (notification: Notification) => {
	toast.success(notification.metadata.message, {
		description: notification.metadata.description,
	});
};

const notificationErrorToast = (notification: Notification) => {
	toast.error(notification.metadata.message, {
		description: notification.metadata.description,
	});
};

type NotificationToastMap = Partial<
	Record<NotificationTypes, (notification: Notification) => void>
>;

const toasts: NotificationToastMap = {
	DocumentSendSuccess: notificationSuccessToast,
	DocumentSendError: notificationErrorToast,
	ApplicationSendError: notificationErrorToast,
	ApplicationSendSuccess: notificationSuccessToast,
};

/**
 * Display configured toast message for the provided notification.
 */
export function showNotificationToast(notification: Notification) {
	if (toasts[notification.type] === undefined) {
		return notificationInfoToast(notification);
	}
	toasts[notification.type]?.(notification);
}
